import { lazy } from 'react';
import type { RouteObject } from 'react-router';
import { ModalOutlet } from '~/application/outlet/ModalOutlet';

const DeletePage = lazy(() => import('./pages/delete'));
const ImportPage = lazy(() => import('./pages/import'));
const IndexPage = lazy(() => import('./pages/index'));

export default {
    path: '/receiving-lists',
    title: 'Liste za zaprimanje',
    Component: IndexPage,
    children: [{
        Component: ModalOutlet,
        children: [{
            path: 'import',
            Component: ImportPage,
        }],
    }, {
        path: ':listId',
        Component: ModalOutlet,
        children: [{
            path: 'delete',
            Component: DeletePage,
        }],
    }],
} satisfies RouteObject;
